import React, { useContext, useEffect, useState } from 'react';
import "./ActionCenter.css"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import END_POINT from '../../END_POINT';
const ActionCenter = ({data,setUsers}) => {
    
    const userContext = useContext(UserContext);
    const [user, setUser] = useState(userContext);
    const navigate=useNavigate();
    const [updateUser, setUpdateUser] = useState({
        first:"",
        last:"",
        email:"",
        newpassword:"",
    });
    
    
    
    const deleteAccount=async()=>{

        if(updateUser){
           const res= await fetch(`${END_POINT}/auth/deleteAccount/${updateUser._id}`)
            
            if(res.status===200){
                res.json()
                .then(data=>{
                    
                    setUsers(data);
                    if(user){
                        if(user._id==updateUser._id){
                            setUser("")
                            localStorage.removeItem("User");
                            window.location.reload(true);
                        }
                        
                    }
                })
            }
            
        }
        
    }
    const handleInput=(e)=>{
        setUpdateUser({...updateUser,[e.target.name]:e.target.value})
        
    }
    const submitUpdate=async()=>{
        const res = await fetch(`${END_POINT}/auth/updateProfileadmin`, {
            method: "POST",
            headers: { 'Content-Type': "application/json" },
            body: JSON.stringify(updateUser)
        })
        if(res.status===200){
            res.json().then(data=>{
                //localStorage.setItem("User", JSON.stringify(data));
                
                setUsers(data)
                setUpdateUser(data)
                toast.success('Account Updated Successfully!', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    });
            })
            
              
            // navigate("/login")
          }
          else if(res.status==500){
            toast.error('Update Failed!', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              });
          }
           
    }
    return (
        <div className="">
            {/* <Navbar/> */}
            <div className="viewuser">



                <div>

                    <h3 style={{ "borderBottom": "1px solid grey" }}>Total User: {data.length}</h3>
                    <table className="table table-dark my-3">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Email</th>
                                
                                <th scope="col">Status</th>
                                <th scope="col">Actions</th>

                                
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((data1, index) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{data1.email}</td>
                                            
                                            <td>
                                            <div className="form-check form-switch">
  <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" />
</div>
                                            </td>
                                            <td>
                                            <i onClick={()=>setUpdateUser(data1)} data-toggle="modal" data-target="#exampleModal" className="fas fa-edit mr-3"></i>
                                            <i onClick={()=>{setUpdateUser(data1); deleteAccount()}} className="far fa-trash-alt mx-4"></i>
                                            </td>

                                            
                                        </tr>
                                    )
                                })

                            }

                        </tbody>
                    </table>
                </div>
            </div>
            {/* modal */}


<div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 style={{"color":"black"}} className="modal-title black" id="exampleModalLabel">Update Admin</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
      <div className="form-group">
                    <label className='makeitblack'>First Name</label>
                    <input value={updateUser.first} name='first' onChange={handleInput} type="text" className="form-control"  />
                </div>
                
                <div className="form-group">
                    <label className='makeitblack'>Last Name</label>
                    <input value={updateUser.last} name='last' onChange={handleInput} type="text" className="form-control"  />
                </div>
                <div className="form-group">
                    <label className='makeitblack'>Email</label>
                    <input value={updateUser.email} name='email' onChange={handleInput} type="text" className="form-control"  />
                </div>
                <div className="form-group">
                    <label className='makeitblack'>New Password</label>
                    <input value={updateUser.newpassword}  name='newpassword' placeholder='optional' onChange={handleInput} type="text" className="form-control" />
                </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button onClick={submitUpdate}  type="button" data-dismiss="modal" className="btn btn-primary">Update</button>
      </div>
    </div>
  </div>
</div>
            {/* modal end */}

        </div>
    )
};

export default ActionCenter;
